export enum AptDoiConfirmModeType {
    CheckCall = 'CHECK CALL',
    CheckDoi = 'CHECK DOI',
    TacitoAssensoSms = 'TACITO_ASSENSO_SMS',
    NessunaConferma = 'NESSUNA CONFERMA',
}
